// TODO enable eslint
/* eslint-disable consistent-return */
import warning from "warning"

const initYandexMetrika = counterId => {
  if (typeof window === `undefined`) {
    return false
  }
  // https://yandex.ru/support/metrika/general/creating-counter.html
  /* eslint-disable */
  ;(function(d, w, c) {
    ;(w[c] = w[c] || []).push(function() {
      try {
        w[`yaCounter${counterId}`] = new Ya.Metrika2({
          id: counterId,
          clickmap: true,
          trackLinks: true,
          accurateTrackBounce: true,
          webvisor: true,
        })
      } catch (e) {
        warning(false, `Yandex Metrika error: ${e}`)
      }
    })

    var n = d.getElementsByTagName("script")[0],
      s = d.createElement("script"),
      f = function() {
        n.parentNode.insertBefore(s, n)
      }
    s.type = "text/javascript"
    s.async = true
    s.src = "https://mc.yandex.ru/metrika/tag.js"

    if (w.opera == "[object Opera]") {
      d.addEventListener("DOMContentLoaded", f, false)
    } else {
      f()
    }
  })(document, window, "yandex_metrika_callbacks2")
  /* eslint-enable */
}

export default initYandexMetrika
